/* eslint-disable */
import Vue from 'vue'
import store from '@/store/index'
import OT from '@opentok/client'

class OpenTok {
  errorHandler (error:any, handler:String) {
    console.error({ error, handler })
  }

  async detectSupportedShareScreen () {
    try {
      OT.checkScreenSharingCapability((response) => {
        if (!response.supported || response.extensionRegistered === false) {
          store.state.support.OT.shareScreen = false
        } else if (response.extensionInstalled === false) {
          store.state.support.OT.shareScreen = false
        } else {
          store.state.support.OT.shareScreen = true
        }
      })
    } catch (error) {
      this.errorHandler(error, 'detectSupportedShareScreen')
    }

    return store.state.support.OT.shareScreen
  }

  async getSupportedCodec () {
    let codec = 'VP8'

    try {
      const supportedCodecs = await OT.getSupportedCodecs()
      if (supportedCodecs.videoEncoders.indexOf('VP8') < 0 && supportedCodecs.videoDecoders.indexOf('VP8') < 0) {
        store.state.support.OT.codec = 'H264'
        codec = 'H264'
      }
    } catch(error) {
      this.errorHandler(error, 'getSupportedCodec')
    }

    Vue.prototype.$storage.setCodec(codec)

    return store.state.support.OT.codec
  }
}

Vue.prototype.openTok = new OpenTok()
